import apolloClient from "app/graphql/apolloClient";
import customerActions from "../../actions";
import commonActions from "../../../common/actions";
import messagesActions from "core/state/redux/data/messages/actions";
import queryActions from "core/state/redux/data/queries/actions";
import queryLoader from "app/graphql/queryLoader";
export default async (store, action) => {
  try {
    let cart_id = store.getState().customer.data.cart.id;
    const { data } = await apolloClient.mutate({
      mutation: queryLoader("placeOrder"),
      variables: {
        // cartInput: {
        //   cart_id: cart_id,
        // },
        input: {
          cart_id,
          // payment_method: action.payload,
        },
      },
    });

    store.dispatch(
      customerActions.placeOrderSuccess(data.placeOrder.order.order_id)
    );
    store.dispatch(customerActions.createEmptyCart());
  } catch (error) {
    store.dispatch(messagesActions.addMessage(error.toString(), "danger"));
    store.dispatch(commonActions.unlock());
    store.dispatch(queryActions.removeQuery());
    return;
  }
};
